const formatTimeSlot = (hours, minutes) => {
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};
export const generateTimeSlots = () => {
    const timeSlots = [];
    const MINUTE_INTERVAL = 15;
    const MINUTES_PER_HOUR = 60;
    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < MINUTES_PER_HOUR; minute += MINUTE_INTERVAL) {
            const timeString = formatTimeSlot(hour, minute);
            timeSlots.push(timeString);
        }
    }
    return timeSlots;
};
const floorToHour = (slot) => {
    const h = Number(slot.split(":")[0]) || 0;
    return `${h.toString().padStart(2, "0")}:00`;
};
const ceilToNextHour = (slot) => {
    const h = Number(slot.split(":")[0]) || 0;
    const nextHour = Math.min(h + 1, 24);
    return nextHour < 24 ? `${nextHour.toString().padStart(2, "0")}:00` : "24:00";
};
export const getVisibleDayTimeSlots = (fullSlots, rows) => {
    const slotsWithValues = new Set();
    for (const row of rows) {
        for (const slot of fullSlots) {
            const value = row.timeSlots[slot];
            if (value != null && Number(value) !== 0) {
                slotsWithValues.add(slot);
            }
        }
    }
    if (slotsWithValues.size === 0) {
        return fullSlots;
    }
    const sorted = [...slotsWithValues].sort();
    const firstSlot = sorted[0];
    const lastSlot = sorted[sorted.length - 1];
    if (firstSlot === undefined || lastSlot === undefined) {
        return fullSlots;
    }
    const startSlot = floorToHour(firstSlot);
    const endSlotExclusive = ceilToNextHour(lastSlot);
    const lastFullSlot = fullSlots[fullSlots.length - 1];
    if (lastFullSlot === undefined)
        return fullSlots;
    return fullSlots.filter((s) => s >= startSlot &&
        (endSlotExclusive === "24:00" ? s <= lastFullSlot : s < endSlotExclusive));
};
//# sourceMappingURL=forecastTimeSlotTransform.js.map